export class RepairHistory {
    RepairId: number;
    IsCompleted: boolean;
    CompletedAt: Date | string;
}
